import { getAppConfig } from '@shared/app-config'
import { APP_API_URL, APP_AUTH_API_URL, APP_WEBSOCKET_URL } from '@shared/config/raw-env'

export function getEnv() {
  const config = getAppConfig()
  return {
    APP_API_URL: config.env?.APP_API_URL || APP_API_URL,
    APP_AUTH_API_URL: config.env?.APP_AUTH_API_URL || APP_AUTH_API_URL,
    APP_WEBSOCKET_URL: config.env?.APP_WEBSOCKET_URL || APP_WEBSOCKET_URL,
  }
}
